module.exports = __webpack_public_path__ + "images/7c3c862efe834d78c04eee184bb27110.png";